var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u7ED3\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-781.000000, -775.000000)",
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782,775 L782,790 L784,790 L784,788 L788,788 L788,790 L790,790 L790,786 L794,786 L794,790 L796,790 L796,788 L800,788 L800,791 L781,791 L781,775 L782,775 Z M788,784 L788,787 L784,787 L784,784 L788,784 Z M800,785 L800,787 L796,787 L796,785 L800,785 Z M794,780 L794,785 L790,785 L790,780 L794,780 Z M788,781 L788,783 L784,783 L784,781 L788,781 Z M794,777 L794,779 L790,779 L790,777 L794,777 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon_chart.5bcdfc96382751ef622b9fde70962f09.svg";
export { ForwardRef as ReactComponent };